import {
  Dashboard_GET_REQUEST,
  Dashboard_GET_SUCCESS,
  Dashboard_GET_FAIL,
  Dashboard_GET_RESET,
} from "../Constants/DashboardConstants";

export const dashboardGetReducer = (
  state = { recordItem: undefined },
  action
) => {
  switch (action.type) {
    case Dashboard_GET_REQUEST:
      return { ...state, loading: true };
    case Dashboard_GET_SUCCESS:
      return { loading: false, recordItems: action.payload.items };
    case Dashboard_GET_FAIL:
      return { loading: false, error: action.payload };
    case Dashboard_GET_RESET:
      return {};
    default:
      return state;
  }
};
